import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue";
const _hoisted_1 = ["src", "alt"];
const _hoisted_2 = { class: "card-content" };
const _hoisted_3 = { class: "card-label-row" };
const _hoisted_4 = ["innerHTML"];
const _hoisted_5 = {
    key: 0,
    class: "account-avatars"
};
const _hoisted_6 = ["src", "alt"];
const _hoisted_7 = {
    key: 0,
    class: "avatar avatar-badge"
};
const _hoisted_8 = { class: "remaining-count" };
const _hoisted_9 = {
    key: 0,
    class: "card-balance-row"
};
const _hoisted_10 = { class: "card-balance" };
import { computed } from 'vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'AccountCard',
    props: {
        label: {},
        icon: { default: null },
        illustrationColor: { default: '#C6CAE5' },
        accountIcons: { default: () => [] },
        balance: { default: null }
    },
    emits: ["click"],
    setup(__props, { emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const formattedLabel = computed(() => {
            if (!props.label)
                return '';
            if (props.balance)
                return props.label;
            return props.label.replace(/ /g, '<br>');
        });
        const displayAvatars = computed(() => {
            if (!props.accountIcons)
                return [];
            if (props.accountIcons.length <= 3) {
                return props.accountIcons;
            }
            return props.accountIcons.slice(0, 2);
        });
        const remainingCount = computed(() => {
            if (!props.accountIcons || props.accountIcons.length <= 3) {
                return 0;
            }
            return props.accountIcons.length - 2;
        });
        function handleClick() {
            emit('click', { label: props.label });
        }
        function handleImageError(event) {
            event.target.src = require('@/assets/round1.png');
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: "account-card",
                onClick: handleClick
            }, [
                _createElementVNode("div", {
                    class: "card-illustration",
                    style: _normalizeStyle({ backgroundColor: _ctx.illustrationColor })
                }, [
                    (_ctx.icon)
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: _ctx.icon,
                            alt: _ctx.label,
                            class: "illustration-icon"
                        }, null, 8, _hoisted_1))
                        : _createCommentVNode("", true)
                ], 4),
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("p", {
                            class: "card-label",
                            innerHTML: formattedLabel.value
                        }, null, 8, _hoisted_4),
                        (_ctx.accountIcons && _ctx.accountIcons.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayAvatars.value, (iconUrl, index) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        key: index,
                                        class: "avatar"
                                    }, [
                                        _createElementVNode("img", {
                                            src: iconUrl,
                                            alt: `Account ${index + 1}`,
                                            onError: handleImageError
                                        }, null, 40, _hoisted_6)
                                    ]));
                                }), 128)),
                                (remainingCount.value > 0)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                        _createElementVNode("span", _hoisted_8, "+" + _toDisplayString(remainingCount.value), 1)
                                    ]))
                                    : _createCommentVNode("", true)
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    (_ctx.balance)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                            _createElementVNode("p", _hoisted_10, _toDisplayString(_ctx.balance), 1)
                        ]))
                        : _createCommentVNode("", true)
                ])
            ]));
        };
    }
});
